import { WIND_SPEED_LINE, WindSpeedChart } from '@/components/spotter/historicalDataTab/WindSpeedAndDirectionSection';
import { AlertTriggerReferenceChartProps } from '@/components/spotter/notificationTab/AlertReferenceChart';
import { useAlertsFromForm } from '@/components/spotter/notificationTab/useAlertsFromForm';
import { useSpotterContext } from '@/context/SpotterContext';

const LINES = [WIND_SPEED_LINE];

export const WindSpeedAlertReferenceChart = ({ enabled = false }: AlertTriggerReferenceChartProps) => {
    const { spotterId } = useSpotterContext();
    const alerts = useAlertsFromForm();

    if (!spotterId) {
        return;
    }

    return (
        <WindSpeedChart
            chartTitle={'Wind speed alert'}
            spotterId={spotterId}
            queryEnabled={enabled}
            showAlertLines={true}
            scaleToFitAlerts={true}
            lines={LINES}
            alertLines={alerts}
        />
    );
};
